import { fetch, Method } from 'core/api/fetch';

const getList = async ({ entity, search, input, ids }, apiVersion = 'v1.1.1') => {
    try {
        let url = `/api/${apiVersion}/experiencer/search/${entity}?`;

        if (ids && ids.length > 0) {
            if (Array.isArray(ids)) {
                ids.forEach((id) => {
                    url += `ids=${id}&`;
                });
            } else {
                url += `ids=${ids}&`;
            }
            url = url.slice(0, -1);
        } else {
            url += `${search}=${input || ''}`;
        }

        const response = await fetch(url, {
            method: Method.GET,
            authenticated: true,
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.data || !Array.isArray(response.data)) {
            return { data: [] };
        }

        return { data: response.data };
    } catch (error) {
        return { data: [] };
    }
};

const getListByExperienceId = async ({ entity, search, input, experienceId }) => {
    try {
        const url = `/api/v1.1.1/experiencer/search/${entity}?${search}=${input}&experienceId=${experienceId}`;

        const response = await fetch(url, {
            method: Method.GET,
            authenticated: true,
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.data || !Array.isArray(response.data)) {
            return { data: [] };
        }

        return { data: response.data };
    } catch (error) {
        return { data: [] };
    }
};

export const EntityService = {
    getList,
    getListByExperienceId,
};

export const EntityServiceV2 = {
    getList: async (params) => getList(params, 'v2'),
};
